import { createApi } from "@reduxjs/toolkit/query/react";

import type { CatalogDTO } from "../../../types/Catalog";
import { createServiceBaseQuery } from "../../../../../store/client/serviceBaseQuery";

export const catalogService = createApi({
  reducerPath: "catalogService",
  baseQuery: createServiceBaseQuery("orpheusUri"),
  tagTypes: ["Catalog"],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getCatalogById: builder.query<CatalogDTO, { catalogId: string }>({
      query: (arg) => {
        const { catalogId } = arg;
        return {
          url: `/api/catalogs/${catalogId}`,
          method: "GET",
        };
      },
      providesTags: [{ type: "Catalog", id: "DETAIL" }],
    }),
  }),
});
export const { useGetCatalogByIdQuery } = catalogService;
